import React, { useState } from 'react';
import {
  Box,
  Tab,
  Paper
} from '@mui/material';
import ConsoleTabs from '../common/ConsoleTabs';
import AccessibilityAdmin from './AccessibilityAdmin';
import ProjectNoCommonLibManagement from './ProjectNoCommonLibManagement';
import SnykAdmin from './SnykAdmin';
import SnykMapping from './SnykMapping';
import HipaaCuiAdmin from './HipaaCuiAdmin';
import H22026Admin from './H22026Admin';

const ComplianceAdmin = () => {
  const [tabValue, setTabValue] = useState(0);

  return (
    <Box>
      <Paper sx={{ mb: 2 }}>
        <ConsoleTabs
          value={tabValue}
          onChange={(_, v) => setTabValue(v)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Accessibility" />
          <Tab label="Projects No Common Lib" />
          <Tab label="SNYK" />
          <Tab label="SNYK Mapping" />
          <Tab label="HIPAA/CUI" />
          <Tab label="H2-2026 Planning" />
        </ConsoleTabs>
      </Paper>

      {tabValue === 0 && <AccessibilityAdmin />}
      {tabValue === 1 && <ProjectNoCommonLibManagement />}
      {tabValue === 2 && <SnykAdmin />}
      {tabValue === 3 && <SnykMapping />}
      {tabValue === 4 && <HipaaCuiAdmin />}
      {tabValue === 5 && <H22026Admin />}
    </Box>
  );
};

export default ComplianceAdmin;

